export function SkeletonKpis({ count }: { count: number }) {
  return (
    <div className="kpi-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="kpi"
          style={{
            background:
              "linear-gradient(90deg, var(--c-surface) 0%, var(--c-surface-sunk) 50%, var(--c-surface) 100%)",
            backgroundSize: "200% 100%",
            animation: "skeleton 1.4s ease-in-out infinite",
          }}
        />
      ))}
      <style>{`@keyframes skeleton { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>
    </div>
  );
}
